// cart drwer js start
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".add-to-cart").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            let form = this.closest("form");
            if (!form) {
                console.error("No form found for this add-to-cart button.");
                return;
            }

            let formData = new FormData(form);

            fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                body: formData,
                headers: {
                    "Accept": "application/json"
                }
            })
            .then(response => response.json())
            .then(data => {
                console.log("🛒 Added to cart:", data);

                // ✅ Fire Impulse's cart update event manually
                document.dispatchEvent(new Event("cart:build"));

                // ✅ Force a cart drawer refresh using native Shopify cart update
                fetch(window.Shopify.routes.root + "cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
                    });

                // ✅ Open the cart drawer manually
                document.documentElement.classList.add("js-drawer-open");
                let cartDrawer = document.querySelector("#CartDrawer");
                if (cartDrawer) {
                    cartDrawer.classList.add("drawer--is-open");
                }
            })
            .catch(error => {
                console.error("❌ Fetch error:", error);
            });
        });
    });

    // ✅ Event Delegation to Ensure Close Button Works
    document.addEventListener("click", function (event) {
        if (event.target.closest(".js-drawer-close")) {
            closeCartDrawer();
        }
    });

    // ✅ Close cart drawer when clicking outside of it
    document.addEventListener("click", function (event) {
        let cartDrawer = document.querySelector("#CartDrawer");
        if (cartDrawer && cartDrawer.classList.contains("drawer--is-open")) {
            if (!cartDrawer.contains(event.target) && !event.target.closest(".add-to-cart")) {
                closeCartDrawer();
            }
        }
    });

    function closeCartDrawer() {
        document.documentElement.classList.remove("js-drawer-open");
        let cartDrawer = document.querySelector("#CartDrawer");
        if (cartDrawer) {
            cartDrawer.classList.remove("drawer--is-open");
        }
    }
});




